export const clearCacheAndReload = () => {
    if ('caches' in window) {
        caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
                caches.delete(cacheName)
            })
        })
    }
    window.location.reload()
}
